import React from "react";
import { MatchDetailsData } from "@/pages/buddy/types/MatchDetailsData";
import { HardCriteriaComparison, SkillCriterion } from "@/pages/buddy/match/blocks";
import { LLMLog } from "@/pages/buddy/shared/debug/llm_log.tsx";

interface MatchContentProps {
    activePage: string;
    match: MatchDetailsData;
    onRefresh: () => Promise<void>;    // NEW
}

const MatchContent = ({ activePage, match, onRefresh  }: MatchContentProps) => {
    const renderOverview = () => (
        <>
            <div className="grid lg:grid-cols-3 gap-5 lg:gap-7.5">
                {/* Left section with SkillCriterion */}
                <div className="lg:col-span-2">
                    {Object.entries(match.soft_criteria_details).map(([criterionName, criterionDetail]) => (
                        <div className="mb-7.5" key={criterionName}>
                            <SkillCriterion
                                matchId={match.p_id}                  // NEW
                                onRefresh={onRefresh}                 // NEW
                                criterionName={criterionName}
                                criterionDetail={{
                                    matched_skills: criterionDetail.matched_skills || [],
                                    missing_skills: criterionDetail.missing_skills || [],
                                    additional_skills: criterionDetail.additional_skills || [],
                                    soft_score_absolute: criterionDetail.soft_score_absolute || 0,
                                    soft_score_absolute_max:
                                        criterionDetail.soft_score_absolute_max || 0,
                                    soft_score_relative: criterionDetail.soft_score_relative || 0,
                                    is_reliable: criterionDetail.is_reliable ?? false,
                                    explanation: criterionDetail.explanation || "",
                                    skill_gap_explanation: criterionDetail.skill_gap_explanation || "",
                                }}
                            />
                        </div>
                    ))}
                </div>

                {/* Right section - Hard Criteria Comparison */}
                <div className="lg:col-span-1">
                    <div className="grid gap-5 lg:gap-7.5">
                        <HardCriteriaComparison hardCriteriaResults={match.hard_criteria_results} match_p_id={match.p_id}/>
                    </div>
                </div>
            </div>

            <LLMLog title="LLM Logs (Dev/Testing Only)" llmLogs={match.llm_log || []} />
        </>
    );

    const renderCandidates = () => (
        <div>
            {/* Placeholder for candidate rendering logic */}
            <p>No candidates available.</p>
        </div>
    );

    return (
        <div className="grid grid-cols-1 gap-5 lg:gap-7.5">
            {activePage === "overview" ? renderOverview() : renderCandidates()}
        </div>
    );
};

export { MatchContent };
